const gestorDocumentalEnumerators = {
  filtroVencimiento: ['Vencidos', 'PorVencer', 'Vigentes'],
  tipoDocumento: ['Certificado', 'Licencia', 'Documento', 'Cédula', 'Foto', 'Video', 'Gráfico', 'Mapa', 'Plano', 'Libro'],
};

export default gestorDocumentalEnumerators;
